import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { FoodsService } from '../foods.service';
import { FoodsModel } from '../all-foods/FoodsModel';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { FoodIngredientsModel } from '../all-foods/FoodIngredientsModel';
import { EvaluationFoodsModel } from '../EvaluationFoodsModel';
import { EvaluationEventService } from '../../MasterData/evaluation-event.service';
import { EvaluationFoodsService } from '../evaluation-foods.service';
import { ReportModel } from '../../Reports/ReportModel';
import { ReportService } from '../../Reports/report.service';
@Component({
    // moduleId: module.id,
    selector: 'food-details',
    templateUrl: 'food-details.component.html',
    styleUrls: ['food-details.component.scss']
})
export class FoodDetailsComponent implements OnInit {
    Menuoption = 'center';
    Settingicon = true
      projectDetails : any;
      projectGallaryConfig  = {"slidesToShow": 1,"fade": true, "slidesToScroll": 1,"arrows": false,"dots": false,"autoplay": true, "autoplaySpeed": 2000};
    declare lang: any;
  
      constructor( 
          public router: Router,
          private formBuilder : FormBuilder,
          private modelService :FoodsService,
          private EvaluationFoodsService:EvaluationFoodsService,
          private ReportService:ReportService,
          private route: ActivatedRoute,
          ) {    
              this.Evaluation = [];
              this.id = +route.snapshot.paramMap.get("id");
         }
         id=0;
         ngOnInit() {
          // this.lang = localStorage.getItem('theme_lang');
          if(this.id > 0)
          {
            debugger;
            this.modelService.getById(this.id).subscribe(data=>{
              this.modelObject=data;
              this.files=this.modelObject.foodsImagesList;
              this.IngredientsList=this.modelObject.foodIngredientsList;
              this.EvaluationFoodsService.GetAllByFoodIdId(this.id).subscribe(data=>{
                this.EvaluationFoodList=data;
              })
              console.log("modelObject",this.rows)
  
            })
  
          }
          else{
          }
      }
      selectedIndex: number = 0;
      @Input()
      data:any;
      modelObject: FoodsModel = new FoodsModel();
      rows :FoodsModel[]= [];
      IngredientsList :FoodIngredientsModel[]= [];
      EvaluationFoodList :EvaluationFoodsModel[]= [];
      EvaluationFoodObject: EvaluationFoodsModel = new EvaluationFoodsModel();
      EvaluationFoodForm: FormGroup = new FormGroup({
        id: new FormControl(),
        comment: new FormControl(),
        foodId: new FormControl(),
        numberOfStars: new FormControl(),
        userId: new FormControl(),
        date: new FormControl(),
        time: new FormControl(),
       
    });
    
    public Evaluation:EvaluationFoodsModel[]=[];
    public myComment: string ='';
    public myStars: number =0;
    public myTime: Date =new Date();
    public myDate: Date =new Date();
    Save() {
        debugger;
        this.EvaluationFoodObject = new EvaluationFoodsModel();
        this.EvaluationFoodObject.id = 0;
        this.EvaluationFoodObject.comment = this.myComment;
        this.EvaluationFoodObject.foodId = this.id;
        this.EvaluationFoodObject.numberOfStars = this.myStars;
        this.EvaluationFoodObject.date = this.myDate;
        this.EvaluationFoodObject.time = this.myTime;
        this.EvaluationFoodObject.userId = 0;
        this.EvaluationFoodObject.isHide = false;

        console.log(this.modelObject);
        console.log(this.modelObject);
        this.EvaluationFoodsService.insert(this.EvaluationFoodObject).subscribe((data) => {
          this.myComment='';
          this.myStars=0;
          this.ngOnInit();
          // this.router.navigate(["app/HR/List-Salaries-Manager"]);
        });
      }
    ReportObject:ReportModel=new ReportModel();
    ReportForm:FormGroup=new FormGroup({
    id: new FormControl(),
    message: new FormControl(),
    commentId: new FormControl(),
    userId: new FormControl(),
    });
    public message: string ='';
    commetId=0;
    setCommentId(commetId){
      this.commetId =commetId;

    }
  @ViewChild('closebutton') closebutton;
      SendReport() {
        debugger;
        this.ReportObject = new ReportModel();
        this.ReportObject.id = 0;
        this.ReportObject.message = this.message;
        this.ReportObject.commentId = this.commetId;
        this.ReportObject.userId = 0;
        this.ReportObject.Type = 'foods';
        console.log(this.modelObject);
        this.ReportService.insert(this.ReportObject).subscribe((data) => {
          this.message='';
          this.commetId=0;
          this.closebutton.nativeElement.click();
        });
      }
        files:FoodsModel[]=[];
       public picurl: string ='';
       editEnabled = true;
       
     
        CampDetails(id){
          this.router.navigate(['/camps-details/',id]);
          
        }

        customOptions: OwlOptions = {
            // loop: true,
            mouseDrag: true,
            touchDrag: true,
            pullDrag: false,
            // autoplay: true,
            navSpeed: 700,
            navText: ['', ''],
            responsive: {
              0: {
                items: 1
              },
              600: {
                items: 3
              },
              900: {
                items: 4
              }
            },
            nav: false
          };
  }